export const DEFAULT_REMARKS_ACCENT = "blue";

export const REMARKS_ACCENT_OPTIONS = [
  { value: "blue", label: "Blue" },
  { value: "green", label: "Green" },
  { value: "amber", label: "Amber" },
  { value: "red", label: "Red" },
  { value: "purple", label: "Purple" },
  { value: "gray", label: "Gray" },
];

const REMARKS_ACCENT_VALUES = new Set(
  REMARKS_ACCENT_OPTIONS.map(({ value }) => value),
);

export const normalizeRemarksAccent = (value) =>
  REMARKS_ACCENT_VALUES.has(value) ? value : DEFAULT_REMARKS_ACCENT;
